<template>
  <span class="tooltiptext">{{text}}</span>
</template>
<script>
export default {
  name: 'ToolTip',
  props: {
    text: String,
  },
};
</script>
<style scoped>
.tooltip .tooltiptext {
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}
</style>
